import { useEffect, useState } from 'react';

/**
 * Watches all elements with class "reveal" and adds "in" class
 * when they enter the viewport. Triggers fade + slide up.
 */
export function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

/**
 * Animates a number from 0 to `target` over `duration` ms.
 * Only starts when `startWhen` is true (so we can sync with scroll-into-view).
 */
export function useCountUp(target, duration = 1600, startWhen = true) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!startWhen) return;
    let raf;
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / duration);
      const ease = 1 - Math.pow(1 - p, 3); // easeOutCubic
      setVal(Math.floor(ease * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration, startWhen]);
  return val;
}
